import React from "react"

import * as styles from"./footer.module.scss"

const Footer = ({ menuLinks, socialLinks, postPage }) => {
  return (
    <section className={styles.footerWrap}>
      <div>
        <div className={styles.lrContent}>
          <img src={`/assets/images/logo-white.png`} title={"logo"} alt={"logo"} />
			  {/*<nav className={styles.social}>
            <ul>
              {socialLinks.map((link, index) => (
                <li key={index}>
                  <a href={link.slug} target="_blank" rel="noopener noreferrer">
                    <img
                      src={`/assets/images/icons/${link.name}.svg`}
                      width="40px"
                      height="40px"
                      alt={link.name}
                    />
                  </a>
                </li>
              ))}
            </ul>
			  </nav>*/}
        </div>
        <div className={styles.copyrightwrap}>
          <div className={styles.copyright}>
            © Copyright {new Date().getFullYear()}
            {`, `}
            <a
              style={{ boxShadow: "none" }}
              href={"/"}
              rel="noopener noreferrer"
            >&nbsp;&nbsp;
              {"sThus"}
            </a>
          </div>
          <nav className={styles.menuLinks}>
            <ul>
              {menuLinks.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.slug}
                    key={index}
                    rel="noopener noreferrer"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </section>
  )
}

export default Footer
